// extracted by mini-css-extract-plugin
module.exports = {"productReport":"ProductReport_productReport__JeKhY"};